module.exports = "<div class=\"border\">\n  <span class=\"icon-warning\"></span>\n  <div class=\"errors\">\n    <p ng-if=\"!$ctrl.errors ||  $ctrl.errors.length === 0\">Campos invalidos y/o requeridos</p>\n    <ul ng-if=\"$ctrl.errors && $ctrl.errors.length > 0\">\n      <li ng-repeat=\"error in $ctrl.errors\">{{error}}</li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/formErrorsSummary/formErrorsSummary.html
// module id = 694
// module chunks = 0